import { computed, defineComponent } from 'vue'
  import successIcon from '@/components/icons/Interface/success-toaster.svg'
  import warnIcon from '@/components/icons/Interface/warning-toaster.svg'
  import errorIcon from '@/components/icons/Interface/error-toaster.svg'
  import infoIcon from '@/components/icons/Interface/info-toaster.svg'

  
export default {
  __name: 'ToastAlert',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    actionText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
      validator(value) {
        return ['success', 'warn', 'error', 'info'].includes(value)
      },
    },
    position: {
      type: String,
      default: 'bottom-right',
      validator(value) {
        return [
          'bottom-right',
          'bottom-left',
          'top-right',
          'top-left',
        ].includes(value)
      },
    },
    closable: {
      type: Boolean,
      default: true,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  defineComponent({
    name: 'ToastAlert',
  })

  

  const iconSrc = computed(() => {
    switch (props.type) {
      case 'success':
        return successIcon
      case 'warn':
        return warnIcon
      case 'error':
        return errorIcon
      default:
        return infoIcon
    }
  })

return { __sfc: true,props, iconSrc }
}

}